import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { getCMSBannerList } from '../../../api/services/systemService';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const SectionContainer = styled.section`
  margin: 0 auto;
  text-align: center;
  padding: 0 1.5%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px 0px;
`;

const NewsletterGrid = styled.div`
  width: 90%;
  display: flex;
  flex-wrap: wrap;
  gap: 40px;
  justify-content: center;
`;

const NewsletterCard = styled.div`
  display: flex;
  flex: 1;
  min-width: 200px;
  flex-direction: column;
  align-items: center;
  border-radius: 8px;
  text-decoration: none;
  color: ${(props) => props.theme.colors.primaryText};
  box-sizing: border-box;
  overflow: hidden;
`;

const NewsletterImage = styled.img`
  background-color: rgb(140, 204, 248);
  width: 100%;
  height: auto;
  max-width: 100%;
  display: block;
  cursor: pointer;
`;

const NewsletterFooter = styled.div`
  background-color: #f5f5f5;
  width: 100%;
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

const NewsletterTitle = styled.h3`
  font-size: 1rem;
  font-weight: 500;
  margin: 0;
  text-align: center;
  color: #333;
`;

const ReadMoreLink = styled(Link)`
  font-size: 1rem;
  text-underline-offset: 3px;
  text-decoration: none;
  font-weight: bold;
  color: #2b83bf;

  &:hover {
    text-decoration: underline;
  }
`;

export default function NewsLetterView() {
  const userInfo = useSelector((state) => state.userInfo);

  const [newsletterList, setNewsletterList] = useState([]);

  useEffect(() => {
    getDbNewsLetterList();
  }, []);

  const getDbNewsLetterList = async () => {
    const result = await getCMSBannerList(userInfo.brandCode);
    setNewsletterList(result.cmsBannerList || []);
  };

  return (
    <SectionContainer>
      <NewsletterGrid>
        {newsletterList.map((newsletter) => {
          return (
            <NewsletterCard key={newsletter.title}>
              <NewsletterImage
                src={`${process.env.REACT_APP_FILE_UPLOAD_URL}${newsletter.filepath1}`}
                alt={newsletter.title}
                onClick={() => window.open(newsletter.url, '_blank')}
              />
              <NewsletterFooter>
                <NewsletterTitle>{newsletter.title}</NewsletterTitle>
                <ReadMoreLink to={newsletter.url} target='_blank'>
                  Read More &gt;
                </ReadMoreLink>
              </NewsletterFooter>
            </NewsletterCard>
          );
        })}
      </NewsletterGrid>
    </SectionContainer>
  );
}
